import {defineMessages} from 'react-intl'

export const priceSuffixMessages = defineMessages({
  additionalCharges: {
    id: 'payment.additionalCharges',
    defaultMessage: 'Additional charges may apply'
  },
  includingTaxes: {
    id: 'includingTaxesAndFees',
    defaultMessage: 'incl. taxes & fees'
  },
  withTaxesAndFees: {
    id: 'taxation.withTaxesAndFees',
    defaultMessage: 'with taxes & fees'
  },
  total: {id: 'price.totalV2', defaultMessage: 'total'},
  totalV2: {id: 'total', defaultMessage: 'total'},
  perNight: {id: 'perNight', defaultMessage: '/ night'},
  numberOfRoomsMessage: {
    id: 'numberOfRooms',
    defaultMessage: '{count, plural, one {1 room} other {# rooms}}'
  },
  numberOfNightsMessage: {
    id: 'numberOfNights',
    defaultMessage: '{count, plural, one {1 night} other {# nights}}'
  }
})

// These price data ids are used to distinguish between the total price and the per night price.
// They are used by the GHA crawler to determine the price accuracy.
// Any change to these data ids should be align with the Meta team
export enum RoomOfferPriceDataId {
  Total = 'roomOfferPriceTotal',
  PerNight = 'roomOfferPricePerNight'
}
